import { Injectable } from '@angular/core';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';
import { CareSkill } from 'src/app/shared/models/employee/care-skill';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class CareSkillService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllCareSkills(): Observable<CareSkill[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.careSkillUrl}s`,
			'getAllCareSkills'
		);
	}

	addCareSkill(careSkill: CareSkill): Observable<CareSkill> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.careSkillUrl}`,
			'addCareSkill',
			careSkill
		);
	}

	updateCareSkill(careSkill: CareSkill): Observable<CareSkill> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.careSkillUrl}`,
			'updateCareSkill',
			careSkill
		);
	}

	deleteCareSkill(careSkillId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.careSkillUrl}/${careSkillId}`,
			'deleteCareSkill'
		);
	}
}
